import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 2h-14a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z","key":"svg-0"}]]

const IconSquareFilled = createReactComponent('filled', 'square-filled', 'SquareFilled', __iconNode);

export default IconSquareFilled;